export default "__VITE_ASSET__DCK9Sb64__"